<template>
  <aha-modal
    title="Don’t lose out!"
    ref="remove-card-info-popup"
    id="remove-card-info-popup"
    @hide="handleStayBtn()"
  >
    <img
      src="@/assets/images/elements/dont-leave-subscription.svg"
      class="ml-auto mr-auto mb-4"
    >
    <p class="mb-4">
      Your plan is currently on our old pricing scheme,
      <b>meaning you’re paying less than new users.</b>
    </p>
    <p class="mb-4">
      If you cancel your plan and buy a new one, you’ll pay the updated price.
    </p>
    <p>Are you sure you want to continue?</p>
    <template #action>
      <aha-button
        @click="handleStayBtn"
        has-margin-right
      >
        Stay
      </aha-button>
      <aha-link
        @click="handleContinueBtn"
      >
        <span class="font-bold">Continue</span>
      </aha-link>
    </template>
  </aha-modal>
</template>
<script>
export default {
  name: 'CancelSubInfo',
  data() {
    return {
    }
  },
  mounted() {
  },
  methods: {
    handleContinueBtn() {
      this.$router.push({ name: 'UserCancelSub' })
    },
    handleStayBtn() {
      this.$emit('close')
    },
  },
}
</script>
